import { Component, Inject, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NewsletterVisualizarResponse } from 'app/shared/models/ei-models/newsletter/response/newsletter-visualizar.response';
import { NewsletterService } from 'app/shared/services/edduca-imob';
import { GlobalService } from 'app/shared/services/core';
import { GamificacaoHandler } from 'app/shared/components/gamificacao';

@Component({
  selector: 'app-newsletter-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './newsletter-modal.component.html',
  styleUrl: './newsletter-modal.component.scss'
})
export class NewsletterModalComponent implements OnInit {
  private _globalService = inject(GlobalService);
  private _gamificacaoHandler = inject(GamificacaoHandler);
  
  newsletter?: NewsletterVisualizarResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public id: number,
    private newsletterService: NewsletterService,
    public dialogRef: MatDialogRef<NewsletterModalComponent>
  ) {}

  ngOnInit(): void {
    const usuarioId = this._globalService.getIdUserLogged();
    
    this.newsletterService.obtemNewsletterPorId(this.id, usuarioId).subscribe({
      next: res => {
        this.newsletter = res;
        // Processar gamificação se houver
        if (res?.gamificacao) {
          this._gamificacaoHandler.processarGamificacao(res.gamificacao);
        }
      },
      error: err => {
        console.error('Erro ao buscar newsletter:', err);
        this.dialogRef.close();
      }
    });
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
